export const COMMS_READONLY_STATUS = ['03','60','90']
export const COMMS_CHANNELS_CLIENTE = (app_status) => [
  {
    key: 'gestor',
    value: 'Comunicación con Gestor',
    readOnly: COMMS_READONLY_STATUS.includes(app_status),
  },
]

